var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhyInvestBannerOrnament = function SvgWhyInvestBannerOrnament(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 210 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 5.004,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 205 5.004)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165,
    cy: 5,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 165 5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 5,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 125 5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 4.998,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 85 4.998)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 5.004,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 45 5.004)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5.002,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 5 5.002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 40.005,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 205 40.005)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165,
    cy: 40.003,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 165 40.003)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 40.003,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 125 40.003)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 39.997,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 85 39.997)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 40.001,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 45 40.001)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 40.003,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 5 40.003)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 75.002,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 205 75.002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165,
    cy: 74.998,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 165 74.998)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 75.002,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 125 75.002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 74.998,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 85 74.998)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 75,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 45 75)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 75,
    rx: 4.998,
    ry: 5,
    transform: "rotate(90 5 75)"
  }))));
};
export default SvgWhyInvestBannerOrnament;